<template>
	<div class="app-floating-boxes">
		<floating-box v-for="box in boxes" :key="box.id" :params="box" @close="onClose"/>
	</div>
</template>

<script>
import uniqueid from '@/utils/uniqueid'
import FloatingBox from './FloatingBox'
export default {
	components: {
		FloatingBox
	},
	data () {
		return {
			boxes: []
		}
	},
	methods: {
		createBox (title, text) {
			this.boxes.push({
				id: uniqueid(),
				title,
				text
			})
		},
		removeBox (box) {
			const jsonBox = JSON.stringify(box)
			this.boxes = this.boxes.filter(element => JSON.stringify(element) !== jsonBox)
		},
		onAddBox (box) {
			this.createBox(box.title, box.text);
		},
		onClose (box) {
			this.removeBox(box)
		}
	},
	mounted () {
		this.$root.$on('add-floating-box', this.onAddBox)
	},
	beforeDestroy () {
		this.$root.$off('add-floating-box', this.onAddBox)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/boxes/FloatingBoxes.vue